import React, {useEffect, useState} from "react";
import {Button, DialogActions, DialogContent} from "@mui/material";
import {useTranslation} from "react-i18next";
import FullscreenDialog from "../fullscreen-dialog";
import I18nHtmlEditor from "../i18n-html-editor";

export function TextEditingDialog({open, onClose, handleTextChange, initialValue}) {
  const [textValue, setTextValue] = useState(undefined);
  const {t} = useTranslation();

  useEffect(() => {
    setTextValue(initialValue);
  }, [initialValue]);

  return (
    <FullscreenDialog
      id="item-container-_builder__text-editing-dialog"
      open={open}
      onClose={onClose}
      title={t("components.itemContainerBuilder.modals.text.title")}
    >
      <DialogContent id="item-container__text-editing-dialog__content">
        <I18nHtmlEditor value={textValue} onChange={setTextValue} height={640} />
      </DialogContent>
      <DialogActions>
        <Button id="item-container__text-editing-dialog__cancel-btn" onClick={onClose}>
          {t("commons.confirm.cancel")}
        </Button>
        <Button
          id="item-container__text-editing-dialog__confirm-btn"
          onClick={() => {
            handleTextChange(textValue);
            onClose();
          }}
        >
          {t("commons.confirm.confirm")}
        </Button>
      </DialogActions>
    </FullscreenDialog>
  );
}
